/** Data model for a "user" */
export interface IUser {
    demographics: IUserDemographics;
    applicationSettings: IApplicationSettings;
    paymentSettings: IPaymentSettings;

    tier: UserTierLevel;
}

/** Demographic info about this user */
export interface IUserDemographics {
    firstName:      string;
    lastName:       string;
    email:          string;
    attorneys:      string[];

    proxyUserID:    string | null;
}

/** User's Payment Tier Level */
export enum UserTierLevel {
    Trial = "tier-trial",
    FreeUser = "tier-free",
    Tier1User = "tier-1",
    TestTier3 = "test-tier-3"
}

/** Payment info for this user */
export interface IPaymentSettings {

}

/** Users application settings */
export interface IApplicationSettings { 

}

/** Implementation of IUserDemographics */
export class UserDemographics implements IUserDemographics {
    public firstName:      string = "";
    public lastName:       string = "";
    public email:          string = "";
    public attorneys:      string[] = [];
    public proxyUserID:    string | null = "";
    public constructor(firstName: string, lastName: string, email: string) {
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
    }

    public static getDefault(): IUserDemographics { return new UserDemographics("", "", ""); }
}